import React from 'react';
import PropTypes from 'prop-types';
import messages from '../../lib/messages.js';
import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';

import textIcon from './text.svg';

const TextModeComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.text}
    imgSrc={textIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="T"
  />
);

TextModeComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default TextModeComponent;
